import { classNames } from "../App";

export default function CustomNumberInput({ className, value, onChange, placeholder, register, min, max, step, disabled = false }) {
    return <input className={classNames('rounded-lg text-neutral-400 py-2 px-4 border border-neutral-border focus:outline-none',
        className
    )} min={min} max={max} step={step} type="number" value={value} onChange={onChange} placeholder={placeholder} disabled={disabled} {...register} />
}